var $modal = (function() {
	var $ = jQuery;

	var config = {
		ready: false,
		modalClass: '.modal',
		hideByEsc: true
	};

	// modal.__setAnimationEndEvent();

	/**
	 * cache: {id: $modal}
	 * @type {{}}
	 */
	var dialogMap = {};
	/**
	 * visible dialogs stack
	 * @type {Array}
	 */
	var dialogList = [];

	var sbWidth = __getScrollBarWidth();

	/*
		var modals = $(config.modalClass);
		modals.each(function(i, item) {
			dialogMap[item.id] = $(item);
		});
	*/

	return {
		/**
		 * Show dialog
		 */
		show: show,
		hide: hide
	};

	/**
	 * Show dialog
	 * @param id
	 * @param args
	 * 			data : object
	 * 			beforeOpen : callback($modal, data)
	 * 			afterOpen : callback($modal, data)
	 * 			actions : for attributes data-action : callback($modal, data)
	 * @returns {boolean}
	 */
	function show(id, args) {
		args = args || {};
		var $modal = dialogMap[id];
		if( typeof $modal === 'undefined' ) {
			$modal = $('#' + id);
			if( !$modal.length ) {
				$modal = false;
			}
			dialogMap[id] = $modal;
		}
		if( $modal ) {
			var $modalBox = $('<div class="modal-box"></div>').append($modal).appendTo('body');
			var dialog = {id: id, $box: $modalBox, $modal: $modal};
			dialogList.push(dialog);

			dialog.args = args;

			if( args.beforeOpen && args.beforeOpen($modal, args.data) === false ) {
				return false;
			}

			if( args.actions ) {
				dialog.actions = {};
				for( var act in args.actions ) {
					dialog.actions[act] = {
						$item: $modal.find('*[data-action="' + act + '"]')
								.on('click', {modal: $modal, data: args.data, callback: args.actions[act]}, function(e) {
									e.preventDefault();
									e.data.callback(e.data.modal, e.data.data);
								}),
						callback: args.actions[act]
					};
				}
			}

			$('body').css({'overflow-y': 'hidden', 'padding-right': __isDocumentScrollable() ? sbWidth : 0});
			$modalBox.addClass('visible');

			if( args.afterOpen ) {
				args.afterOpen($modal, args.data);
			}

			$modalBox.click(function(e) {
				if( e.target === e.currentTarget ) {
					hide();
				}
			});

			if( config.hideByEsc ) {
				$(window).on('keyup', __keyPress);
			}

			return true;
		}
	}

	function hide() {
		if( dialogList.length > 0 ) {
			var dialog = dialogList[dialogList.length - 1];
			if( dialog.args.beforeHide && dialog.args.beforeHide(dialog.$modal, dialog.args.data) === false ) {
				return false;
			}

			dialogList.pop();

			dialog.$box.detach().empty();
			$('body').css({'overflow-y': '', 'padding-right': ''});
			if( config.hideByEsc ) {
				$(window).off('keyup', __keyPress);
			}

			if( dialog.actions ) {
				for( var act in dialog.actions ) {
					dialog.actions[act].$item.off('click', dialog.actions[act].callback);
				}
			}

			if( dialog.args.afterHide ) {
				dialog.args.afterHide(dialog.$modal, dialog.args.data);
			}

			return true;
		}
	}

	function __keyPress(e) {
		e.preventDefault();

		if( e.keyCode === 27 ) {
			hide();
		}
	}

	function __getScrollBarWidth() {
		var div = document.createElement('div');
		div.style.cssText = 'visibility:hidden;width:100px;height:100px;overflow-y:scroll';
		document.body.appendChild(div);

		var sbWidth = div.offsetWidth - div.clientWidth;

		document.body.removeChild(div);
		return sbWidth;
	}

	function __isDocumentScrollable() {
		var docHeight, viewHeight;

		if( window.innerHeight && window.scrollMaxY )
			docHeight = window.innerHeight + window.scrollMaxY;
		else if( document.body.scrollHeight > document.body.offsetHeight ) // all but Explorer Mac
			docHeight = document.body.scrollHeight;
		else if( document.documentElement && document.documentElement.scrollHeight > document.documentElement.offsetHeight ) // Explorer 6 strict mode
			docHeight = document.documentElement.scrollHeight;
		else
			docHeight = document.body.offsetHeight;

		if( self.innerHeight ) // all except Explorer
			viewHeight = self.innerHeight;
		else if( document.documentElement && document.documentElement.clientHeight ) // Explorer 6 Strict Mode
			viewHeight = document.documentElement.clientHeight;
		else if( document.body ) // other Explorers
			viewHeight = document.body.clientHeight;

		return viewHeight < docHeight;
	}
})();

